{
  "version": 1,
  "asset_id": "de8c4c36-e559-4cd7-a237-552a0dd97bdb",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/de8c4c36-e559-4cd7-a237-552a0dd97bdb/lecanto-metal-roof-before-1320w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/de8c4c36-e559-4cd7-a237-552a0dd97bdb/lecanto-metal-roof-before-1320w.webp",
  "original_filename": "lecanto-metal-roof-before-1320w.webp",
  "size": 358572,
  "content_type": "image/webp",
  "created_at": "2026-07-21T19:37:57Z"
}
